import { createFileRoute } from '@tanstack/react-router';
import PreviewPage from '@/features/resume-builder/preview';

/** EU-762 RN-26..28 — "Prévia do currículo" (pelo perfil, DEV-483). */
export const Route = createFileRoute('/perfil/curriculo/previa')({
  component: PreviewPage,
});
